// @ts-ignore
/* eslint-disable */
// @ts-ignore
import { request } from '@umijs/max';
import { Md5 } from 'ts-md5';

/** 登录接口 POST /api/login/account */
export async function login(body: API.LoginParams) {
  const data = await request<API.ResponseModel<API.LoginModel>>('/login', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: {
      ...body,
      password: Md5.hashStr(body.password!),
    },
  });
  return data.data;
}

/** 获取当前用户 GET */
export async function getCurrentUser() {
  const data = await request<API.ResponseModel<API.UserInfoModel>>('/current_user', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    data: {},
  });
  return data.data;
}

// 获取用户列表
export async function getUserList(
  params: {
    pageSize?: number;
    current?: number;
  },
  options?: { [key: string]: any },
): Promise<API.PageResult<API.UserModel>> {
  const data = await request<API.ResponseModel<API.PageResult<API.UserModel>>>('/get_users', {
    method: 'POST',
    data: {
      page: params.current,
      pageSize: params.pageSize,
    },
    ...(options || {}),
  });
  return data.data!;
}

// 新建用户
export async function addUser(params: {
  [key: string]: any;
}){
  const data = await request<API.ResponseModel<any>>('/users', {
    method: 'PUT',
    data: {
      ...params,
    },
  });
  return data.data!;
}

// 更新用户
export async function updateUser(params: {
  [key: string]: any;
}) {
  const data = await request<API.ResponseModel<any>>('/users', {
    method: 'POST',
    data: {
      ...params,
    },
  });
  return data.data!;
}

// 更新用户密码
export async function updateUserPassword(params: {
  [key: string]: any;
}): Promise<API.PageResult<API.UserModel>> {
  const data = await request<API.ResponseModel<API.PageResult<API.UserModel>>>('/user_password', {
    method: 'POST',
    data: {
      ...params,
    },
  });
  return data.data!;
}

// 删除用户
export async function removeUser(params: {
  ids: number[];
}) {
  const data = await request<API.ResponseModel<any>>('/users', {
    method: 'DELETE',
    data: {
      ids: params.ids,
    },
  });
  return data.data!;
}

// 获取全部的角色
export async function getAllRole() {
  const data = await request<API.ResponseModel<API.RoleList[]>>('/get_all_roles', {
    method: 'GET',
  });
  return data?.data;
}

// 获取角色列表
export async function getRoleList(
  params: {
    pageSize?: number;
    current?: number;
  },
  options?: { [key: string]: any },
) {
  const data = await request<API.ResponseModel<API.RoleList[]>>('/get_role_list', {
    method: 'POST',
    data: {
      page: params.current,
      pageSize: params.pageSize,
    },
    ...options,
  });
  return data.data!;
}

//新建角色
export async function addRole(params: {
  [key: string]: any;
}): Promise<API.PageResult<API.UserModel>> {
  const data = await request<API.ResponseModel<any>>('/roles', {
    method: 'PUT',
    data: {
      ...params,
    },
  });
  return data.data!;
}

// 更新角色
export async function updateRole(params: {
  [key: string]: any;
}) {
  const data = await request<API.ResponseModel<any>>('/roles', {
    method: 'POST',
    data: {
      ...params,
    },
  });
  return data.data!;
}

// 删除角色
export async function removeRole(params: {
  ids: number[];
}) {
  const data = await request<API.ResponseModel<any>>('/roles', {
    method: 'DELETE',
    data: {
      ids: params.ids,
    },
  });
  return data.data!;
}


//获取全部的权限列表
export async function getAllPermissions() {
  const data = await request<API.ResponseModel<API.PermissionResult[]>>('/permissions', {
    method: 'GET',
  });
  return data.data!
}

//获取sts token
export async function getStsToken() {
  const data = await request<API.ResponseModel<API.StsResult>>('/get_sts_token', {
    method: "GET"
  })
  return data.data!;
}

/** 获取规则列表 GET /api/rule */
export async function rule(
  params: {
    // query
    /** 当前的页码 */
    current?: number;
    /** 页面的容量 */
    pageSize?: number;
  },
  options?: { [key: string]: any },
) {
  return request<API.RuleList>('/api/rule', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 更新规则 PUT /api/rule */
export async function updateRule(options?: { [key: string]: any }) {
  return request<API.RuleListItem>('/api/rule', {
    method: 'POST',
    data: {
      method: 'update',
      ...(options || {}),
    },
  });
}

/** 新建规则 POST /api/rule */
export async function addRule(options?: { [key: string]: any }) {
  return request<API.RuleListItem>('/api/rule', {
    method: 'POST',
    data: {
      method: 'post',
      ...(options || {}),
    },
  });
}

/** 删除规则 DELETE /api/rule */
export async function removeRule(options?: { [key: string]: any }) {
  return request<Record<string, any>>('/api/rule', {
    method: 'POST',
    data: {
      method: 'delete',
      ...(options || {}),
    },
  });
}
